exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".new-comment[data-v-4c83afbf]{height:150px;border-radius:5px}\n", ""]);

